import { render, staticRenderFns } from "./ModalRespaldos.vue?vue&type=template&id=265b75de&"
import script from "./ModalRespaldos.vue?vue&type=script&lang=js&"
export * from "./ModalRespaldos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports